import { useMutation } from '@tanstack/react-query';

import { respondToSupplierActivation } from './respondToSupplierActivation';
import { type SupplierActivationRespondMutationOptions } from './types';

/**
 * React Query based custom hook for submitting a supplier's activation response
 * via the magic link flow (public, no authentication).
 *
 * No query invalidation is performed because this endpoint is accessed by
 * unauthenticated suppliers who have no other queries to keep in sync.
 *
 * @param options - Optional mutation options.
 * @returns The mutation result.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Suppliers-Activation-(Public)/operation/post_supplier_activation_respond_api_v1_suppliers_activation__req_id__respond_post
 */
export const useMutationSupplierActivationRespond = (
  options?: SupplierActivationRespondMutationOptions,
) =>
  useMutation({
    mutationFn: async ({ payload, reqId, token }) =>
      respondToSupplierActivation({
        payload,
        reqId,
        token,
      }),
    throwOnError: false,
    ...options,
  });
